import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import InstallPrompt from "components/InstallPrompt";
import NotFound from "pages/NotFound";
import HomePage from './pages/home';
import TruckMarketplace from './pages/truck-marketplace';
import BuyerOperationsDashboard from './pages/buyer-operations-dashboard';
import TransporterDashboard from './pages/transporter-dashboard';
import LoginAuthentication from './pages/login-authentication';
import SugarMarketplaceDashboard from './pages/sugar-marketplace-dashboard';
import AdminControlPanel from './pages/admin-control-panel';
import AdminDashboard from './pages/admin-dashboard';
import SugarQuota from './pages/factory-management-hub';
import SugarQuotaAnalysis from './pages/sugar-quota-analysis';
import NewsAndMarketPrices from './pages/news-and-market-prices';
import LiveShipmentTracking from './pages/live-shipment-tracking';
import ReportsGenerationCenter from './pages/reports-generation-center';
import DriverAuthentication from './pages/driver-authentication';
import DriverRegistrationProfile from './pages/driver-registration-profile';
import ManagerAuthentication from './pages/manager-authentication';
import ManagerDashboard from './pages/manager-dashboard';
import FactoryQuotaManagerDashboard from './pages/factory-quota-manager-dashboard';
import FactoryRegistrationProfileManagement from './pages/factory-registration-profile-management';
import QuotaAllocationPricingCenter from './pages/quota-allocation-pricing-center';
import FactoryBuyerMarketplaceView from './pages/factory-buyer-marketplace-view';
import FactoryTransporterManagement from './pages/factory-transporter-management';
import BulkDataUploadCenter from './pages/bulk-data-upload-center';
import SugarOrderRequestForm from './pages/sugar-order-request-form';
import AppSitemap from './pages/app-sitemap';
import UserRegistration from './pages/user-registration';
import RegistrationPending from './pages/registration-pending';
import SellYourSugar from './pages/sell-your-sugar';
import AuthCallback from './pages/auth-callback';
import DriverLocationPage from './pages/driver-location';
import Profile from './pages/Profile';
import TeamAccess from './pages/TeamAccess';
import NotificationSettings from './pages/NotificationSettings';
import ChangePassword from './pages/ChangePassword';
import PrivacyPolicy from './pages/privacy-policy';
import TermsAndConditions from './pages/terms';
import RefundPolicy from './pages/refund';
import Pricing from './pages/pricing';
import AboutUs from './pages/about';
import ContactUs from './pages/contact';
import MonitorDashboard from './pages/monitor-dashboard/index';
import DoVerifyPage from './pages/do-verify';
import TrackingPage from './pages/track';
import SalesAgentDashboard from './pages/sales-agent-dashboard';
import DoFinanceApply from './pages/do-finance-apply';
import AdminCommissionManagement from './pages/admin-commission-management';
import ProtectedRoute from './components/ProtectedRoute';
import GovtSugarQuotaTracker from './pages/market-intelligence';
import MIStatePage from './pages/market-intelligence/state';
import MIDistrictPage from './pages/market-intelligence/district';
import MIFactoryPage from './pages/market-intelligence/factory';
import MIComparePage from './pages/market-intelligence/compare';
import MISearchPage from './pages/market-intelligence/search';
import MIStatesBrowse from './pages/market-intelligence/states';
import MIDistrictsBrowse from './pages/market-intelligence/districts';
import MIFactoriesBrowse from './pages/market-intelligence/factories';
import MIStatewiseAllocation from './pages/market-intelligence/statewise-allocation';
import MandiPage from './pages/mandi';
import MandiFactoryDetail from './pages/mandi/factory';
// LiveTenderInfo: no longer public (pending legal/compliance review of the
// scraped source data) — now mounted admin-only below at /admin-live-tender-info.
import LiveTenderInfo from './pages/live-tender-info';
import FactoryDirectory from './pages/factory-directory';
import FactoryRateIntelligenceCenter from './pages/factory-rate-intelligence-center';
import FactoryRateShareView from './pages/factory-rate-intelligence-center/share';
import RateApprovalQueue from './pages/rate-approval-queue';
import MySubmissions from './pages/my-submissions';
import SubmissionHistory from './pages/submission-history';
import FroEmailCenter from './pages/fro-email-center';
import ScraperControl from './pages/scraper-control';
const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <InstallPrompt />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HomePage />} />
        <Route path="/app-sitemap" element={<AppSitemap />} />
        <Route path="/sugar-order-request-form" element={<SugarOrderRequestForm />} />
        <Route path="/sell-your-sugar" element={<SellYourSugar />} />
        <Route path="/truck-marketplace" element={<TruckMarketplace />} />
        <Route path="/buyer-operations-dashboard" element={<ProtectedRoute element={<BuyerOperationsDashboard />} allowedRoles={['buyer','admin']} />} />
        <Route path="/transporter-dashboard" element={<ProtectedRoute element={<TransporterDashboard />} allowedRoles={['transporter','admin']} />} />
        <Route path="/login-authentication" element={<LoginAuthentication />} />
        <Route path="/sugar-marketplace-dashboard" element={<SugarMarketplaceDashboard />} />
        <Route path="/admin-control-panel" element={<ProtectedRoute element={<AdminControlPanel />} allowedRoles={['admin']} />} />
        <Route path="/admin-dashboard" element={<ProtectedRoute element={<AdminDashboard />} allowedRoles={['admin']} />} />
        <Route path="/sugar-quota" element={<ProtectedRoute element={<SugarQuota />} allowedRoles={['factory_admin','admin']} />} />
        <Route path="/factory-management-hub" element={<ProtectedRoute element={<SugarQuota />} allowedRoles={['factory_admin','admin']} />} />
        <Route path="/sugar-quota-analysis" element={<ProtectedRoute element={<SugarQuotaAnalysis />} allowedRoles={['factory_admin','admin','quota_manager']} />} />
        <Route path="/news-and-market-prices" element={<NewsAndMarketPrices />} />
        <Route path="/live-shipment-tracking" element={<ProtectedRoute element={<LiveShipmentTracking />} allowedRoles={['monitor','admin']} />} />
        <Route path="/reports-generation-center" element={<ProtectedRoute element={<ReportsGenerationCenter />} allowedRoles={['buyer','factory','transporter','admin']} />} />
        <Route path="/driver-authentication" element={<DriverAuthentication />} />
        <Route path="/driver-registration-profile" element={<DriverRegistrationProfile />} />
        <Route path="/driver-location" element={<DriverLocationPage />} />
        <Route path="/manager-authentication" element={<ManagerAuthentication />} />
        <Route path="/manager-dashboard" element={<ProtectedRoute element={<ManagerDashboard />} allowedRoles={['quota_manager','admin']} />} />
        <Route path="/factory-quota-manager-dashboard" element={<ProtectedRoute element={<FactoryQuotaManagerDashboard />} allowedRoles={['factory_admin','admin']} />} />
        <Route path="/factory-registration-profile-management" element={<ProtectedRoute element={<FactoryRegistrationProfileManagement />} allowedRoles={['factory_admin','admin']} />} />
        <Route path="/quota-allocation-pricing-center" element={<ProtectedRoute element={<QuotaAllocationPricingCenter />} allowedRoles={['quota_manager','admin']} />} />
        <Route path="/factory-buyer-marketplace-view" element={<ProtectedRoute element={<FactoryBuyerMarketplaceView />} allowedRoles={['factory_admin','admin']} />} />
        <Route path="/factory-transporter-management" element={<ProtectedRoute element={<FactoryTransporterManagement />} allowedRoles={['factory_admin','admin']} />} />
        <Route path="/bulk-data-upload-center" element={<ProtectedRoute element={<BulkDataUploadCenter />} allowedRoles={['admin']} />} />
        <Route path="/register" element={<UserRegistration />} />
        <Route path="/user-registration" element={<UserRegistration />} />
        <Route path="/registration-submitted" element={<AuthCallback />} />
        <Route path="/registration-pending" element={<RegistrationPending />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/auth-callback" element={<AuthCallback />} />
        <Route path="/profile" element={<ProtectedRoute element={<Profile />} />} />
        <Route path="/team-access" element={<ProtectedRoute element={<TeamAccess />} />} />
        <Route path="/notifications" element={<ProtectedRoute element={<NotificationSettings />} />} />
        <Route path="/change-password" element={<ProtectedRoute element={<ChangePassword />} />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/refund" element={<RefundPolicy />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/do-verify" element={<Navigate to="/verify" replace />} />
        <Route path="/verify" element={<DoVerifyPage />} />        
        <Route path="/monitor-dashboard" element={<ProtectedRoute element={<MonitorDashboard />} allowedRoles={['monitor','admin']} />} />
        <Route path="/sales-agent-dashboard" element={<ProtectedRoute element={<SalesAgentDashboard />} allowedRoles={['sales_agent','admin']} />} />
        <Route path="/do-finance/apply" element={<ProtectedRoute element={<DoFinanceApply />} allowedRoles={['buyer','sales_agent','admin']} />} />
        <Route path="/admin-commission-management" element={<ProtectedRoute element={<AdminCommissionManagement />} allowedRoles={['admin']} />} />
        <Route path="/market-intelligence" element={<GovtSugarQuotaTracker />} />
        <Route path="/market-intelligence/state/:stateSlug" element={<MIStatePage />} />
        <Route path="/market-intelligence/district/:districtSlug" element={<MIDistrictPage />} />
        <Route path="/market-intelligence/factory/:millSlug" element={<MIFactoryPage />} />
        <Route path="/market-intelligence/compare" element={<MIComparePage />} />
        <Route path="/market-intelligence/search" element={<MISearchPage />} />
        <Route path="/market-intelligence/states" element={<MIStatesBrowse />} />
        <Route path="/market-intelligence/districts" element={<MIDistrictsBrowse />} />
        <Route path="/market-intelligence/factories" element={<MIFactoriesBrowse />} />
        <Route path="/market-intelligence/statewise-allocation" element={<MIStatewiseAllocation />} />
        <Route path="/mandi" element={<MandiPage />} />
        <Route path="/mandi/:factorySlug" element={<MandiFactoryDetail />} />
        {/* /livetenderinfo (the old public path) is intentionally NOT re-added here —
            visiting it falls through to the catch-all NotFound route below (404),
            same as any unknown URL. The scraped data is only reachable by an admin,
            through this dedicated route, gated the same way every other admin page
            in this app is gated (ProtectedRoute + allowedRoles=['admin'], backed by
            user_profiles.role via useAuth()/AuthContext — see ProtectedRoute.jsx).
            Route-level protection is a UI convenience only; the real enforcement is
            the admin-only RLS policy on ebuysugar_tender_listings (see
            supabase/migrations/20260822100000_admin_only_ebuysugar_tender_read.sql),
            so even a signed API request from a non-admin session returns no rows. */}
        <Route path="/admin-live-tender-info" element={<ProtectedRoute element={<LiveTenderInfo />} allowedRoles={['admin']} />} />
	<Route path="/internal-factory-directory" element={<ProtectedRoute element={<FactoryDirectory />} />} />
        {/* factory_relations_officer's own rate-submission form. Role-gated the same
            way every other role-specific page in this app is (ProtectedRoute +
            allowedRoles) — 'admin' included per the app-wide convention that admin
            can always reach any role-specific page (see e.g. /quota-allocation-
            pricing-center, /sugar-quota). This is defense-in-depth UI only; the real
            boundary is RLS (mpq_officer_insert_own, mpq_officer_select_own),
            unchanged by this. */}
        <Route path="/factory-rate-intelligence-center" element={<ProtectedRoute element={<FactoryRateIntelligenceCenter />} allowedRoles={['factory_relations_officer', 'admin']} />} />
        <Route path="/factory-rate-intelligence-center/share/:millId" element={<ProtectedRoute element={<FactoryRateShareView />} />} />
        <Route path="/rate-approval-queue" element={<ProtectedRoute element={<RateApprovalQueue />} />} />
        {/* Officer's own submission-tracking view — same role-gate as above. */}
        <Route path="/my-submissions" element={<ProtectedRoute element={<MySubmissions />} allowedRoles={['factory_relations_officer', 'admin']} />} />
        <Route path="/fro-email-center" element={<ProtectedRoute element={<FroEmailCenter />} allowedRoles={['factory_relations_officer', 'admin']} />} />
        <Route path="/submission-history" element={<ProtectedRoute element={<SubmissionHistory />} allowedRoles={['factory_relations_officer', 'admin', 'quota_manager']} />} />
        <Route path="/scraper-control" element={<ProtectedRoute element={<ScraperControl />} allowedRoles={['admin']} />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/track" element={<TrackingPage />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};
export default Routes;


